/**
 * Tabs — frontend behaviour
 *
 * Progressive enhancement: without JS every panel is visible.
 * With JS, only the active panel is shown.
 */

function initTabs(wrapper) {
    const buttons = wrapper.querySelectorAll(':scope > .purso-tabs__tablist > .purso-tabs__button[role="tab"]');
    const panels = wrapper.querySelectorAll(':scope > .purso-tabs__panels > .purso-tabs__panel[role="tabpanel"]');

    if (!buttons.length || !panels.length) return;

    const defaultTab = parseInt(wrapper.dataset.defaultTab, 10) || 0;

    function activate(index) {
        buttons.forEach((btn, i) => {
            const isActive = i === index;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
            btn.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel, i) => {
            panel.hidden = i !== index;
        });
    }

    // Click handler
    buttons.forEach((btn, i) => {
        btn.addEventListener('click', () => {
            activate(i);
        });
    });

    // Keyboard navigation
    wrapper.querySelector('.purso-tabs__tablist').addEventListener('keydown', (e) => {
        const currentIndex = Array.from(buttons).indexOf(document.activeElement);
        if (currentIndex === -1) return;

        let nextIndex;
        switch (e.key) {
            case 'ArrowRight':
                nextIndex = (currentIndex + 1) % buttons.length;
                break;
            case 'ArrowLeft':
                nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
                break;
            case 'Home':
                nextIndex = 0;
                break;
            case 'End':
                nextIndex = buttons.length - 1;
                break;
            default:
                return;
        }

        e.preventDefault();
        buttons[nextIndex].focus();
        activate(nextIndex);
    });

    // Initial state
    activate(defaultTab);
}

document.querySelectorAll('.purso-tabs').forEach(initTabs);
